"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyDictForShow = exports.genStringFromArray = exports.printOrLog = exports.logInString = exports.print = exports.feel_list_with_values_if_empty = exports.truncate = exports.deepCopy = exports.argMax = exports.range = exports.func_mean = exports.func_sum = exports.zip = void 0;
var zip = function (arr) {
    var arrs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        arrs[_i - 1] = arguments[_i];
    }
    return arr.map(function (val, i) { return arrs.reduce(function (a, arr) { return __spreadArray(__spreadArray([], a, true), [arr[i]], false); }, [val]); });
};
exports.zip = zip;
function func_sum(array) {
    var sum1 = array.reduce(function (accumulator, currentValue) { return accumulator + currentValue; });
    return sum1;
}
exports.func_sum = func_sum;
function func_mean(array) {
    var suma = 0;
    for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
        var x = array_1[_i];
        suma += x;
    }
    var mean = suma / array.length;
    return mean;
}
exports.func_mean = func_mean;
function range(start, stop, step) {
    if (typeof stop == 'undefined') {
        // one param defined
        stop = start;
        start = 0;
    }
    if (typeof step == 'undefined') {
        step = 1;
    }
    if ((step > 0 && start >= stop) || (step < 0 && start <= stop)) {
        return [];
    }
    var result = [];
    for (var i = start; step > 0 ? i < stop : i > stop; i += step) {
        result.push(i);
    }
    return result;
}
exports.range = range;
function argMax(array) {
    return array.map(function (x, i) { return [x, i]; }).reduce(function (r, a) { return (a[0] > r[0] ? a : r); })[1];
}
exports.argMax = argMax;
function deepCopy(obj) {
    var copy;
    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj)
        return obj;
    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    // Handle Array
    else if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = deepCopy(obj[i]);
        }
        return copy;
    }
    // Handle Object
    else if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr))
                copy[attr] = deepCopy(obj[attr]);
        }
        return copy;
    }
}
exports.deepCopy = deepCopy;
function truncate(val, low, high) {
    if (low === void 0) { low = 0; }
    if (high === void 0) { high = 1; }
    var truncatedVal = val;
    if (val < low) {
        truncatedVal = low;
    }
    else if (val > high) {
        truncatedVal = high;
    }
    return truncatedVal;
}
exports.truncate = truncate;
function feel_list_with_values_if_empty(default_val, list_to_feel, number_of_value_to_feel) {
    if (list_to_feel.length == 0) {
        for (var i = 0; i < number_of_value_to_feel; i++)
            list_to_feel.push(default_val);
    }
    return list_to_feel;
}
exports.feel_list_with_values_if_empty = feel_list_with_values_if_empty;
function print(dataToPrint, toPrint, condToPrint) {
    // console.log("toPrint");
    // console.log(toPrint);
    // console.log(condToPrint);
    if (toPrint && condToPrint) {
        if (Array.isArray(dataToPrint)) {
            dataToPrint = genStringFromArray(dataToPrint);
        }
        else {
            if (dataToPrint.constructor == Object) {
                dataToPrint = stringifyDictForShow(dataToPrint);
            }
        }
        console.log(dataToPrint);
    }
}
exports.print = print;
function logInString(dataToLog, toLog, condToLog, stringToLogIn) {
    // console.log("toLog");
    // console.log(toLog);
    // console.log(condToLog);
    // console.log(stringToLogIn);
    if (toLog && condToLog && stringToLogIn != "") {
        if (Array.isArray(dataToLog)) {
            dataToLog = genStringFromArray(dataToLog);
        }
        //console.log(join(__dirname, stringToLogIn));
        stringToLogIn += '\n' + dataToLog;
    }
}
exports.logInString = logInString;
var zpdes_log_params = {
    "toLogInFile": true,
    "toPrint": true,
    "stringToLogIn": "zpdesLogFile.json",
    "toLog": {
        "set_bandit_state": [0],
        "initialise_ssb": [0],
    }
};
function printOrLog(dataToPrintOrLog, logParams, logEntry, logValue) {
    var toLog = logParams["toLogInFile"];
    var toPrint = logParams["toPrint"];
    var condToPrintOrLog = (logParams["toLog"][logEntry].includes(logValue));
    var stringToLogIn = logParams["stringToLogIn"];
    //console.log("entered in printOrLog");
    print(dataToPrintOrLog, toPrint, condToPrintOrLog);
    logInString(dataToPrintOrLog, toLog, condToPrintOrLog, stringToLogIn);
}
exports.printOrLog = printOrLog;
function genStringFromArray(arrayToString) {
    var myString = "";
    for (var _i = 0, arrayToString_1 = arrayToString; _i < arrayToString_1.length; _i++) {
        var str = arrayToString_1[_i];
        if (str.constructor == Object) {
            myString += "\n";
            myString += stringifyDictForShow(str);
        }
        else {
            myString += String(str);
            myString += " ";
        }
    }
    myString += "\n";
    return myString;
}
exports.genStringFromArray = genStringFromArray;
function stringifyDictForShow(dict) {
    var string = "";
    for (var key in dict) {
        string += key + ": " + JSON.stringify(dict[key]);
        string += "\n";
    }
    return string;
}
exports.stringifyDictForShow = stringifyDictForShow;
